<template>
  <div class="select-box" v-clickOutside="vCloseEvent">
    <div class="select-box-container" @click="vOpen">
      <span class="selected-value">
        {{selected.libelle || this.$props.placeholder}}
        <small>
          <i>({{nCountSelection}} {{nCountSelection === 1 || nCountSelection === 0 ? 'sélectionné' : 'sélectionnés' }})</i>
        </small>
      </span>
      <div class="arrow-down" v-bind:class="{ rotate: opened }">
        <img src="../../assets/img/general/arrow-down.png" />
      </div>
    </div>
    <div class="select-box-dropdown" v-if="opened">
      <div class="selection-container">
        <div class="multiple-selection">
          <span
            class="nb-selected"
          >{{nCountSelection}} {{nCountSelection === 1 || nCountSelection === 0 ? 'sélectionné' : 'sélectionnés' }}</span>
          <span class="selection">{{sSelection}}</span>
        </div>
        <div class="btn-reinit">
          <span :class="opened ? 'toto': ''" @click="vReinit">Réinitialiser</span>
        </div>
      </div>
      <ul>
        <li
          @click="vSelected(item, false, index)"
          v-for="(item, index) in this.$props.data"
          :key="item[itemoption[0]]"
          :class="{ active: vInArray(item) === true  }"
        >
          <div class="option-color" :class="item[itemoption[0]]" v-if="item.THEXA !== undefined ">
            <span :style="{backgroundColor: item.THEXA}"></span>
          </div>
          <div class="selection-libelle">{{item[itemoption[1]]}}</div>
          <div class="selection-box"></div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {},
    placeholder: {
      default: "Veuillez sélectionner une option",
      type: String
    },
    countref: {
      default: -1,
      type: Number
    },
    itemoption: {
      default: () => ["id", "libelle"],
      type: Array
    },
    preselected: {},
    resetselect: {
      default: false,
      type: Boolean
    },
    reference: {},
    uncheck: {}
  },
  data() {
    return {
      selected: Array(),
      aValues: Array(),
      opened: false,
      bPreselection: false,
      sValue: ''
    };
  },
  directives: {
    clickOutside: {
      bind: function(el, binding, vnode) {
        el.clickOutsideEvent = function(event) {
          if (!(el == event.target || el.contains(event.target))) {
            vnode.context[binding.expression](event);
            vnode.context.opened = false;
          }
        };
        document.body.addEventListener("click", el.clickOutsideEvent);
        document.body.addEventListener("touchstart", el.clickOutsideEvent);
      },
      unbind: function(el) {
        document.body.removeEventListener("click", el.clickOutsideEvent);
        document.body.removeEventListener("touchstart", el.clickOutsideEvent);
      },
      stopProp(event) {
        event.stopPropagation();
      }
    }
  },
  methods: {
    vOpen() {
      this.opened = !this.opened;
    },
    vSelected(item, preselected, index, type) {

      let nIndex = this.selected.findIndex(
        test =>
          test[this.$props.itemoption[0]] === item[this.$props.itemoption[0]]
      );

      if (nIndex === -1) {

        if (this.selected.length <= 9) { 
          this.selected.push(item);
        }

        // ********************************

        if (this.$props.countref !== undefined && this.$props.countref !== -1) {
          let nWordLength = item[this.$props.itemoption[0]].length;

          let nCount = this.$props.countref - nWordLength;

          this.sValue += item[this.$props.itemoption[0]] + " ".repeat(nCount);

        } else {
          
          this.sValue += item[this.$props.itemoption[1]] + " ";
        }

        // ********************************

        this.$emit("selectmultiple:selecting", {
          type: "check",
          index,
          custom_value: this.sValue,
          option: item[this.$props.itemoption[0]],
          value: item[this.$props.itemoption[1]],
          reference: this.$props.reference
        });

      } else {

        this.selected.splice(nIndex, 1);

        if (this.$props.countref !== undefined && this.$props.countref !== -1) {

          let nWordLength = item[this.$props.itemoption[0]].length;

          let nCount = this.$props.countref - nWordLength;

          let tmp = item[this.$props.itemoption[0]] + " ".repeat(nCount);

          this.sValue = this.sValue.replace(tmp, '');


        } else {

          let tmp = item[this.$props.itemoption[1]] + " ";

          this.sValue = this.sValue.replace(tmp, '');

        }
       
        this.$emit("selectmultiple:selecting", {
          type: "uncheck",
          index,
          custom_value: this.sValue,
          option: item[this.$props.itemoption[0]],
          value: item[this.$props.itemoption[1]],
          reference: this.$props.reference
        });
      }

      this.$emit("selectmultiple:select", this.sValue);
    },
    vReinit() {
      this.selected = Array();
      this.$emit("selectmultiple:select", '');
      this.$emit("selectmultiple:selecting", {
        type: "uncheckall",
        reference: this.$props.reference
      })
    },
    vInArray(oItem) {
      let oCurrentItem = this.selected.findIndex(
        test =>
          test[this.$props.itemoption[0]] === oItem[this.$props.itemoption[0]]
      );

      if (oCurrentItem === -1) {
        return false;
      } else {
        return true;
      }
    },
    vCloseEvent() {}
  },
  computed: {
    sSelection() {
  
      let sValue = "";
    
      this.selected.map(item => {

        if (this.$props.countref !== undefined && this.$props.countref !== -1) {
          let nWordLength = item[this.$props.itemoption[0]].length;

          let nCount = this.$props.countref - nWordLength;

          sValue += item[this.$props.itemoption[0]] + " ".repeat(nCount);
        } else {
          sValue += item[this.$props.itemoption[1]] + " ";
        }
      });

      return sValue;
    },
    nCountSelection() {
      return this.selected.length;
    }
  },
  watch: {
    resetselect: {
      immediate: true,
      handler(val) {
        if (val === true) {
          this.vReinit();
        }
      }
    },
    preselected() {

      this.data.map((item, nIndex) => {

        if(Array.isArray(this.$props.preselected)) {

          this.$props.preselected.map(preselected => {

            if (item.TMOTCLE === preselected.trim() || item.TID === preselected.trim()) {

              this.selected.push(item);   
                            
              this.$emit("selectmultiple:selecting", {
                type: "check",
                index: nIndex,
                custom_value: item.TMOTCLE !== undefined ? item.TMOTCLE : item.TID,
                option: item[this.$props.itemoption[0]],
                value: item[this.$props.itemoption[1]],
                reference: this.$props.reference
              });
    
              this.$emit("selectmultiple:select", this.$props.preselected);
            }
          });

        } else {

          if (item.TMOTCLE === this.$props.preselected.trim() || item.TID === this.$props.preselected.trim()) {
  
            this.selected.push(item);     
              
            this.$emit("selectmultiple:selecting", {
              type: "check",
              index: nIndex,
              custom_value: item.TMOTCLE !== undefined ? item.TMOTCLE : item.TID,
              option: item[this.$props.itemoption[0]],
              value: item[this.$props.itemoption[1]],
              reference: this.$props.reference
            });
  
            this.$emit("selectmultiple:select", this.$props.preselected);
  
          } else {
            this.selected.splice(nIndex, 1);
          }
        }
      });
    },
    uncheck(val) {

      if(val.type === 'uncheck' && (val.reference === this.$props.reference)) {

        let test = {
          [this.$props.itemoption[0]]: val.option,
          [this.$props.itemoption[1]]: val.value,
        } 

        this.vSelected(test, '', val.index, 'tag');
      }
    }
  },
};
</script>

<style scoped>
.select-box {
  min-width: 320px;
  position: relative;
  margin: 10px;
}
.select-box-container {
  border: solid 1px #e9e9e9;
  padding: 9px 20px;
  background-color: #fff;
  display: flex;
}
.select-box-container .selected-value {
  flex: 1;
}
.select-box-container:hover {
  cursor: pointer;
}
.select-box-container span {
  font-size: var(--fz-md);
}
.select-box-container .arrow-down img {
  width: 12px;
}
.select-value {
  flex: 1;
}
.select-box-dropdown {
  border-bottom: solid 1px #e9e9e9;
  border-left: solid 1px #e9e9e9;
  border-right: solid 1px #e9e9e9;
  background-color: #fff;
  position: absolute;
  width: 100%;
  z-index: 100;
}
.select-box-dropdown ul {
  max-height: 190px;
  overflow: scroll;
}
.select-box-dropdown ul li {
  list-style-type: none;
  font-size: var(--fz-md);
  padding: 9px 20px;
  display: flex;
  align-items: center;
}
.select-box-dropdown ul li.active .selection-box:after {
  content: "";
  width: 10px;
  height: 10px;
  background-color: rgb(97, 66, 77);
  transition: all 0.3s;
}
.select-box-dropdown ul li:hover {
  cursor: pointer;
}
.arrow-down img {
  transition: all 0.2s;
}
.rotate img {
  transform: rotate(180deg);
}
.selection-container {
  display: flex;
  background-color: #f5f5f5;
  padding: 15px 20px;
  border-bottom: solid 1px #e9e9e9;
  flex-wrap: wrap;
}
.multiple-selection {
  display: flex;
  flex-direction: column;
  /* width: 50%; */
  flex: 1;
  justify-content: center;
}
.btn-reinit {
  display: flex;
  align-items: center;
  /* width: 50%; */
  flex: 1;
}
.btn-reinit span {
  border: solid 1px #000;
  padding: 13px 10px;
  width: 100%;
  background: transparent;
  font-size: var(--fz-md);
  font-weight: normal;
  text-align: center;
}
.btn-reinit span:hover {
  cursor: pointer;
}
.nb-selected {
  color: #bfbfbf;
  font-size: var(--fz-md);
}
.selection {
  color: #8b8b8b;
  font-size: var(--fz-md);
  margin-top: 5px;
}
.selection-box {
  border: solid 1px #e9e9e9;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.selection-libelle {
  flex: 1;
  color: rgb(139, 139, 139);
  font-style: italic;
}
.selection-libelle span {
  color: rgb(191, 191, 191);
}
.option-color span {
  width: 15px;
  height: 15px;
  display: block;
  margin-right: 10px;
}
.option-color.BICOLORE span {
  background-image: url("../../../server/static/vignettes/BICOLORE.jpg");
  background-size: contain;
}
.option-color.MULTICOLOR span {
  background-image: url("../../../server/static/vignettes/MULTICOLOR.jpg");
  background-size: contain;
}
</style>